import { inject } from './AsyncScriptLoader';

function getEmbedUserZoomTag() {
  // eslint-disable-next-line no-undef
  if (EmbedUserZoomEnabled) {
    return `//<![CDATA[_uzactions = window._uzactions || [];_uzactions.push(['_setID', '72F5ED62D849E91180DC0050569444FB']);_uzactions.push(['_setSID', '56F3ED62D849E91180DC0050569444FB']);_uzactions.push(['_start']);(function() {var uz = document.createElement('script'); uz.type = 'text/javascript'; uz.async = true; uz.charset = 'utf-8';uz.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'cdn5.userzoom.com/trueintent/js/uz_til_us.js?cuid=0CE748156DCDE41180C90050569444FB';var s = document.getElementsByTagName('script')[0];s.parentNode.insertBefore(uz, s);})();//]]>`;
  }
  return '';
}

const injectUserZoomTag = () => inject('', getEmbedUserZoomTag());

export default injectUserZoomTag;
